export default {
      id: "icon-map-usage",
      viewBox: "0 0 24 24",
      url: "../icon/" + "icons.svg#icon-map-usage",
      toString: function () {
        return this.url;
      }
    }